/* eslint-disable no-magic-numbers */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { ListedCar, CarShortlisted } from 'src/app/core/models/car.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { CarService } from 'src/app/core/services/car.service';

@Component({
  selector: 'app-car-shortlist-content',
  templateUrl: './car-shortlist-content.component.html',
  styleUrls: ['./car-shortlist-content.component.scss',],
})
export class CarShortlistContentComponent implements OnInit {

  isLoading = false;
  vehicleLoadingCount = new Array(9);
  shortlistedCars: ListedCar[] = [];
  @Input() showTitle: boolean = false;
  @Input() defaultNoCols: number = 4;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onExploreCars = new EventEmitter();

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _carService: CarService
  ) { }

  ngOnInit(): void {
    if (!this._authService.getToken()) {
      this._router.navigateByUrl('auth');
    }
    this.loadShortlistedCars();
  }

  loadShortlistedCars() {
    this.isLoading = true;
    this._carService.getShortlisted({}).subscribe({
      next: (carList: CarShortlisted) => {
        this.shortlistedCars = carList.shortlisted;
        const ids = this.shortlistedCars.map((car: ListedCar) => car._id);
        localStorage.setItem(AppConstants.SHORTLISTED_CARS_KEY, JSON.stringify(ids));

      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  browseCars() {
    this.onExploreCars.emit();
    this._router.navigateByUrl('cars');
  }

}
